/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsRosterResponseSchema } from "./goodLuck/core/DTOs/rosterResponseSchema.ts";
import { microsoftAspNetCoreMvcProblemDetailsSchema } from "./microsoft/aspNetCore/mvc/problemDetailsSchema.ts";
import { z } from "zod/v4";

export const getTeamsIdPathParamsSchema = z.object({
  id: z.string().describe("ID команды"),
});

/**
 * @description Возвращает информацию о команде
 */
export const getTeamsId200Schema = z.lazy(
  () => goodLuckCoreDTOsRosterResponseSchema,
);

/**
 * @description Требуется аутентификация
 */
export const getTeamsId401Schema = z.lazy(
  () => microsoftAspNetCoreMvcProblemDetailsSchema,
);

/**
 * @description Команда не найдена
 */
export const getTeamsId404Schema = z.lazy(
  () => microsoftAspNetCoreMvcProblemDetailsSchema,
);

export const getTeamsIdQueryResponseSchema = getTeamsId200Schema;
